import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

function validatePhone(number) {
    let pattern = /^\+48\d{0,9}$/;
    return pattern.test(number);
}

const defaultValue = "+48";

const PhoneTextField = props => {
    const { label, value, onChange, className, name, InputLabelProps } = props;

    const handleChange = (e) => {
        if (validatePhone(e.target.value))
            onChange && onChange(e.target.value);
        else if(e.target.value === "")
            onChange && onChange(defaultValue);
    };

    return (
        <React.Fragment>
            <TextField
                className={className}
                label={label}
                name={name}
                value={value ? value : defaultValue}
                onChange={handleChange}
                InputLabelProps={{...InputLabelProps}}
            />
        </React.Fragment>
    );
};

PhoneTextField.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    InputLabelProps: PropTypes.object
};

export default PhoneTextField;
